"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: credit-report/testing/credit-report-testing-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fcredit-report%2Ftesting%2Fcredit-report-testing-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.testCaseTypeToJSON = exports.testCaseTypeFromJSON = exports.SetUserCreditInsightResponse = exports.SetUserCreditInsightRequest = exports.SetDetailedReportResponse = exports.SetDetailedReportRequest = exports.CreateTestAdminCaseResponse = exports.CreateTestAdminCaseRequest = exports.TestCaseType = void 0;
const insight_1 = require("../insight");
const test_detailed_report_1 = require("../test-detailed-report");
const protobufPackage = 'com.step.creditreport.internal.proto';
var TestCaseType;
(function (TestCaseType) {
    TestCaseType["INVALID_TEST_CASE_TYPE"] = "INVALID_TEST_CASE_TYPE";
    TestCaseType["CREDIT_REPORT_CASE"] = "CREDIT_REPORT_CASE";
    TestCaseType["CREDIT_MONITORING_CASE"] = "CREDIT_MONITORING_CASE";
    TestCaseType["UNRECOGNIZED"] = "UNRECOGNIZED";
})(TestCaseType || (exports.TestCaseType = TestCaseType = {}));
function createBaseCreateTestAdminCaseRequest() {
    return { userId: '', caseType: TestCaseType.INVALID_TEST_CASE_TYPE };
}
exports.CreateTestAdminCaseRequest = {
    fromJSON(object) {
        const message = {
            userId: isSet(object.userId) ? globalThis.String(object.userId) : '',
            caseType: isSet(object.caseType)
                ? testCaseTypeFromJSON(object.caseType)
                : TestCaseType.INVALID_TEST_CASE_TYPE,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userId !== '') {
            obj.userId = message.userId;
        }
        if (message.caseType !== TestCaseType.INVALID_TEST_CASE_TYPE) {
            obj.caseType = testCaseTypeToJSON(message.caseType);
        }
        return obj;
    },
    create(base) {
        return exports.CreateTestAdminCaseRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCreateTestAdminCaseRequest();
        message.userId = object.userId ?? '';
        message.caseType = object.caseType ?? TestCaseType.INVALID_TEST_CASE_TYPE;
        return message;
    },
};
function createBaseCreateTestAdminCaseResponse() {
    return {};
}
exports.CreateTestAdminCaseResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.CreateTestAdminCaseResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseCreateTestAdminCaseResponse();
        return message;
    },
};
function createBaseSetDetailedReportRequest() {
    return { userId: '', report: undefined };
}
exports.SetDetailedReportRequest = {
    fromJSON(object) {
        const message = {
            userId: isSet(object.userId) ? globalThis.String(object.userId) : '',
        };
        if (isSet(object.report)) {
            message.report = test_detailed_report_1.ReportSpec.fromJSON(object.report);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userId !== '') {
            obj.userId = message.userId;
        }
        if (message.report !== undefined) {
            obj.report = test_detailed_report_1.ReportSpec.toJSON(message.report);
        }
        return obj;
    },
    create(base) {
        return exports.SetDetailedReportRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSetDetailedReportRequest();
        message.userId = object.userId ?? '';
        message.report = (object.report !== undefined && object.report !== null)
            ? test_detailed_report_1.ReportSpec.fromPartial(object.report)
            : undefined;
        return message;
    },
};
function createBaseSetDetailedReportResponse() {
    return {};
}
exports.SetDetailedReportResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.SetDetailedReportResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseSetDetailedReportResponse();
        return message;
    },
};
function createBaseSetUserCreditInsightRequest() {
    return { userId: '', transunion: undefined };
}
exports.SetUserCreditInsightRequest = {
    fromJSON(object) {
        const message = {
            userId: isSet(object.userId) ? globalThis.String(object.userId) : '',
        };
        if (isSet(object.transunion)) {
            message.transunion = insight_1.TransUnionCreditData.fromJSON(object.transunion);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userId !== '') {
            obj.userId = message.userId;
        }
        if (message.transunion !== undefined) {
            obj.transunion = insight_1.TransUnionCreditData.toJSON(message.transunion);
        }
        return obj;
    },
    create(base) {
        return exports.SetUserCreditInsightRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSetUserCreditInsightRequest();
        message.userId = object.userId ?? '';
        message.transunion = (object.transunion !== undefined && object.transunion !== null)
            ? insight_1.TransUnionCreditData.fromPartial(object.transunion)
            : undefined;
        return message;
    },
};
function createBaseSetUserCreditInsightResponse() {
    return {};
}
exports.SetUserCreditInsightResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.SetUserCreditInsightResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseSetUserCreditInsightResponse();
        return message;
    },
};
function testCaseTypeFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_TEST_CASE_TYPE':
            return TestCaseType.INVALID_TEST_CASE_TYPE;
        case 1:
        case 'CREDIT_REPORT_CASE':
            return TestCaseType.CREDIT_REPORT_CASE;
        case 2:
        case 'CREDIT_MONITORING_CASE':
            return TestCaseType.CREDIT_MONITORING_CASE;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return TestCaseType.UNRECOGNIZED;
    }
}
exports.testCaseTypeFromJSON = testCaseTypeFromJSON;
function testCaseTypeToJSON(object) {
    switch (object) {
        case TestCaseType.INVALID_TEST_CASE_TYPE:
            return 'INVALID_TEST_CASE_TYPE';
        case TestCaseType.CREDIT_REPORT_CASE:
            return 'CREDIT_REPORT_CASE';
        case TestCaseType.CREDIT_MONITORING_CASE:
            return 'CREDIT_MONITORING_CASE';
        case TestCaseType.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.testCaseTypeToJSON = testCaseTypeToJSON;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=credit-report-testing-service.js.map